import { render, staticRenderFns } from "./localeRouterView.vue?vue&type=template&id=48c37524&scoped=true&"
import script from "./localeRouterView.vue?vue&type=script&lang=js&"
export * from "./localeRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c37524",
  null
  
)

export default component.exports